import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"

// Client-side-only sortable for forms.
// On drag end, renumbers all custom_data[N] field names to match visual order
// so the form submits columns in the correct sequence.
export default class extends Controller {
  connect() {
    this.sortable = new Sortable(this.element, {
      handle:        ".form-sort-handle",
      animation:     150,
      forceFallback: true,
      fallbackClass: "opacity-50 shadow-lg",
      ghostClass:    "bg-indigo-50",
      onEnd:         () => this.reindex()
    })
  }

  disconnect() {
    this.sortable?.destroy()
  }

  reindex() {
    this.element.querySelectorAll(".nested-fields").forEach((item, idx) => {
      item.querySelectorAll("[name]").forEach(el => {
        el.name = el.name.replace(/^(custom_data\[)[^\]]+(\].*)$/, `$1${idx}$2`)
      })
    })
  }
}
